export default function initFloatingBar(elementSelector, topOrBottomPosition) {
    const $element = document.querySelector(elementSelector);
    const elementPosition = $element.offsetTop;

    window.addEventListener('scroll', () => {
        if (isDifferentFromElementPosition(elementPosition, topOrBottomPosition)) {
            addFloat($element, topOrBottomPosition);
            return;
        }

        removeFloat($element, topOrBottomPosition);
    });
}

function isDifferentFromElementPosition(elementPosition, topOrBottomPosition) {
    const topDistance = getTopDistance();

    if (topOrBottomPosition === 'top') {
        return elementPosition - topDistance <= 0;
    }
    if (topOrBottomPosition === 'bottom') {
        return window.innerHeight <= elementPosition - topDistance;
    }

    return false;
}

function getTopDistance() {
    return window.scrollY
        || window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || (window.pageYOffset !== undefined)
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}

function addFloat($element, topOrBottomPosition) {
    if (topOrBottomPosition === 'top') {
        $element.classList.add('fixedTop');
    } else if (topOrBottomPosition === 'bottom') {
        $element.classList.add('fixedBottom');
    }
}

function removeFloat($element, topOrBottomPosition) {
    if (topOrBottomPosition === 'top') {
        $element.classList.remove('fixedTop');
    } else if (topOrBottomPosition === 'bottom') {
        $element.classList.remove('fixedBottom');
    }
}
